// middleware/unauthorizedHandler.ts

import { Middleware } from "@reduxjs/toolkit";
import { clearToken } from "./tokenStore";
import { showLogoutPopup } from "./showLogoutPopup";

const getOAuthRedirectUrl = (): string => {
  const domainHost = window.location.host;
  if (domainHost === "prod.orbico.toa.apprenderesaas.eu") {
    return "https://www.orbicollege.com";
  }
  return "https://devorbicollege.orbico.com";
};

export const unauthorizedHandlerMiddleware: Middleware =
  (store) => (next) => async (action: any) => {
    // Check for rejected async actions with Unauthorized message
    if (action?.payload?.message === "Unauthorized.") {
      console.error("Unauthorized — clearing token and redirecting to login");

      // Clear the in-memory token and sessionStorage copy
      clearToken();

      // Show a banner so the user knows why they are being redirected
      showLogoutPopup();

      // Redirect to the OAuth login page after a short delay
      const redirectUrl = getOAuthRedirectUrl();
      setTimeout(() => {
        window.open(`${redirectUrl}/learn/signin`, "_blank");
      }, 1600);

      return;
    }

    return next(action);
  };
